import React from 'react';
import moment from 'moment/moment';
import { get, capitalize } from 'lodash';
import { SdfBadge, SdfCard, SdfCardHeader, SdfIcon, SdfLink, SdfMiniCard } from '@synerg/react-components';
import usFlag from '../refereshed-components/assets/us-flag-5x.png';
import caFlag from '../refereshed-components/assets/ca-flag-5x.png';

export default function ProjectCard ({ project, product, type, isCreateProdContext, prodProject, goToAssociatedProject }) {
	const {
		// eslint-disable-next-line no-unused-vars
		_id: id = '',
		name = '',
		b2bConsumerAppID = false,
		b2cConsumerAppID = false,
		// eslint-disable-next-line no-unused-vars
		size = 'small',
		platform = 'marketplace',
		caseDisplay,
		appStore,
		status = platform === 'datacloud' ? 'LIVE' : 'NOT_LIVE',
		link,
		// eslint-disable-next-line no-unused-vars
		case: caseCode = '',
		legacy = undefined,
		createdDate
	} = project;

	const productUseCase = legacy ? 'Legacy project No use case' : `${caseDisplay}`;

  const getProjectType = (b2bConsumerAppID, b2cConsumerAppID) => {
    return [
			b2cConsumerAppID ? 'End-user/SSO' : '',
			b2bConsumerAppID ? 'Data connector' : ''
    ].join((b2bConsumerAppID && b2cConsumerAppID) ? ' + ' : '');
  };

  function ProductionStatus({ status = 'Not Live' }) {
		return capitalize(status.replace('_', ' '));
	}

	const colorByStatus = (status = 'not live') => {
		try {
			if (status.status.replace('_', ' ').toLowerCase()) {
				if (status === 'not live') {
					return 'changed';
				}
				else if (status === 'live') {
					return 'complete';
				}
				else if (status === 'suspended') {
					return 'failed';
				} else {
					return 'changed';
				}
			}
		} catch (e) {
			return 'changed';
		}
	}

	return (
		<SdfCard>
	    <div className='justify-between'>
        <div className='flex flex-row-reverse'>
          {link && <div className='grid col-span-1 justify-end'>
            <SdfLink className='cursor-pointer' external=''>
              <SdfIcon icon='action-link' onClick={goToAssociatedProject} />
            </SdfLink>
          </div>}
        </div>

				<SdfCardHeader>
					<SdfMiniCard>
						<div className='flex flex-ro items-center' slot='title'>
							<span className={'text-heading-06 capitalize'}>{name}</span>

							<SdfBadge status={colorByStatus(status)} style={{marginLeft: '7px', height: '32px'}}>
								<ProductionStatus status={status} />
							</SdfBadge>

							{legacy  &&
								<SdfBadge
									style={{marginLeft: '7px', height: '32px'}}
									className='ml'
									status={'default'}
                >
                  Legacy
                </SdfBadge>}
						</div>
					</SdfMiniCard>
				</SdfCardHeader>
				<div className="flex justify-between">
					<div className="flex order-1 justify-start w-5/6">
            <div className="flex justify-between w-4/6">
              <div className="order-1 min-w-3/6 md:max-w-72">
                <div className="order-1 text-heading-03 font-black capitalize">{getProjectType(b2bConsumerAppID, b2cConsumerAppID)}</div>
                <div className="order-2">
                  <div className="text-body-02 grey-text">Added {moment(createdDate).format('MMM DD, YYYY')}</div>
                </div>
              </div>

              <div className="order-2 min-w-2/4">
                <div className="order-1 capitalize">ADP product</div>
                <div className="order-2 text-heading-03 font-black">{product ? get(product, 'label', false) || get(product, 'name', 'other') : 'other'}</div>
              </div>

              <div className="order-3 min-w-3/4 max-w-3/4 flex">
                <div className="order-1 mr-2">
									<div className="order-1">Use case</div>
									<div className="order-2 text-heading-03 font-black">{ productUseCase }</div>
                </div>
	              {platform !== 'datacloud' && <div className="order-2 flex self-end">
                  <img className="h-4 w-2/12" alt="" src={appStore === 'US' ? usFlag : caFlag}/>
                </div>}
              </div>
              </div>
          </div>
          <div className="flex-col order-2 justify-end max-w-1/6">
            <div className="capitalize">
              <SdfLink emphasis='secondary' onClick={goToAssociatedProject}>
              	View Project
              </SdfLink>
            </div>
          </div>
				</div>
	    </div>
	  </SdfCard>
	);
}
